import type { FC, PropsWithChildren } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twMerge } from 'tailwind-merge'

import './styles.scss'

type Size = 'regular' | 'small' | 'medium'

export const LoaderCircle: FC<{ className?: string; size?: Size; whiteLabel?: WhiteLabel }> = ({
  className = '',
  size = 'medium',
  whiteLabel: _whiteLabel,
}) => {
  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = _whiteLabel || storedWhiteLabel || 'control'

  return (
    <div className={twMerge('ui-circle-loader', size, whiteLabel, className)}>
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  )
}

export const LoaderWrapper: FC<
  PropsWithChildren<{ isLoading: boolean; whiteLabel?: WhiteLabel }>
> = ({ isLoading = false, children, whiteLabel }) => {
  if (isLoading) {
    return (
      <div className="ui-circle-loader-container centered">
        <LoaderCircle size="regular" whiteLabel={whiteLabel} />
      </div>
    )
  }

  return <>{children}</>
}
